import commonMessages from '@/lang/messages/common';
import { EnumScreenName, EventProperties } from '@calm/evexia-analytics';
import { useIsMobile } from '@rhg/hooks/use-is-mobile';
import { Box, Button } from '@rhg/libs/material';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import {
    styleButtonGroup,
    styleFlexGrow,
    styleFooterActions,
    styleFooterActionsTransparent,
} from '../styles';

interface AgeGenderFormActionProps {
    formId: string;
    isTransparent?: boolean;
    primaryCtaLabel?: string;
    primaryCtaStartIcon?: ReactNode;
    secondaryCtaLabel?: string;
    showSecondaryCta?: boolean;
    isDisabled?: boolean;
    onCancel?: () => void;
    trackScreen?: EnumScreenName;
    trackProps?: EventProperties;
    trackSubmitProps?: EventProperties;
}

export const AgeGenderFormActions = ({
    isTransparent = false,
    showSecondaryCta,
    secondaryCtaLabel,
    primaryCtaLabel,
    primaryCtaStartIcon,
    onCancel,
    isDisabled,
    formId,
    trackScreen,
    trackProps,
    trackSubmitProps,
}: AgeGenderFormActionProps) => {
    const { formatMessage } = useIntl();
    const isMobile = useIsMobile();

    return (
        <Box
            sx={
                isTransparent
                    ? styleFooterActionsTransparent
                    : styleFooterActions
            }
        >
            <Box sx={styleButtonGroup}>
                {showSecondaryCta && (
                    <Button
                        trackButton="Cancel"
                        trackScreen={trackScreen}
                        trackProps={trackProps}
                        variant="outlined"
                        sx={isMobile ? {} : styleFlexGrow}
                        onClick={onCancel}
                    >
                        {secondaryCtaLabel ??
                            formatMessage(commonMessages['common.cancel'])}
                    </Button>
                )}
                <Button
                    trackButton="SubmitAgeAndGender"
                    trackScreen={trackScreen}
                    trackProps={trackSubmitProps ?? trackProps}
                    variant="contained"
                    sx={styleFlexGrow}
                    startIcon={primaryCtaStartIcon}
                    type="submit"
                    form={formId}
                    disabled={isDisabled}
                >
                    {primaryCtaLabel ??
                        formatMessage(commonMessages['common.submit'])}
                </Button>
            </Box>
        </Box>
    );
};
